<script>

export default {
    name: "AudioRecordingMixin",
    data () {
        return {
            waveSuffer_record: null,
            waveSuffer_player: null,
            mediaRecorder: null,
            recordingBlob: null,
            buttonRecord: {
                icon: '',
                text: ''
            },
            isRecording: false
        }
    },
    methods: {
        initiateRecorder () {
            // recorder
            let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
            let context = null
            let processor = null
            if (isSafari) {
                let AudioContext = window.AudioContext || window.webkitAudioContext
                context = new AudioContext()
                processor = context.createScriptProcessor(1024, 1, 1)
            }
            this.waveSuffer_record = WaveSurfer.create({
                container: '#audioRecord',
                waveColor: '#0052CC',
                interact: false,
                cursorWidth: 0,
                audioContext: context || null,
                audioScriptProcessor: processor || null,
                plugins: [WaveSurfer.microphone.create()]
            })
            this.waveSuffer_record.microphone.on('deviceReady', stream => {
                this.mediaRecorder = new window.MediaRecorder(stream)
                this.mediaRecorder.ondataavailable = event => {
                    this.recordingBlob = event.data
                    this.processRecordingBlob()
                }
                this.mediaRecorder.start()
            })
            this.waveSuffer_record.microphone.on('deviceError', code => {
                console.warn('Device error: ' + code)
                this.buttonRecord.icon = 'fiber_manual_record'
                this.buttonRecord.text = vm.$t('startRecord')
                // un mark recording
                this.isRecording = false
                this.$appService.toastError(vm.$t('deviceNotFound'))
                return false
            })
        },
        toggleRecording () {
            if (this.waveSuffer_record === null) {
                this.initiateRecorder()
            }
            if (this.waveSuffer_record.microphone.active) {
                this.buttonRecord.icon = 'fiber_manual_record'
                this.buttonRecord.text = this.$t('startRecord')
                // un mark recording
                this.isRecording = false
                this.mediaRecorder.stop() // triggers mediaRecorder.onondataavailable
                this.waveSuffer_record.microphone.stop()
                this.mediaRecorder = null
            } else {
                // mark recording
                this.isRecording = true
                this.buttonRecord.icon = 'stop'
                this.buttonRecord.text = this.$t('stopRecord')
                this.waveSuffer_record.microphone.start()
            }
        },
        processRecordingBlob () {
        }
    }
}
</script>
